<template>
  <v-list-item :key="item.title" two-line class="pt-0 pb-0">
    <template v-slot:default="{ active, toggle }">
      <v-row no-gutters>
        <v-list-item-icon class="videolisticon">
          <v-icon style="color: #212121">fa fa-arrow-circle-right</v-icon>
        </v-list-item-icon>
        <v-list-item-icon class="videolisticon ml-10">
          <v-icon>{{ icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content class="ml-8" style="min-width: 100px">
          <v-list-item-title
            class="v-list-asset-title"
            v-text="item.title"
          ></v-list-item-title>
          <v-list-item-subtitle class="text--primary">{{
            item.description
          }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action
          class="list-icon-action"
          style="margin: 0px auto !important"
        >
          <v-btn
            v-if="item.asset_type == 'external link'"
            @click="openDocument(item.external_link, item.id)"
            class="download-btn download-txt"
          >
            <v-img
              src="/static/external-link-icon.png"
              style="margin-right: 11px"
            ></v-img
            >Open Link
          </v-btn>
          <v-btn
            v-else-if="item.asset_type == 'powerpoint'"
            :disabled="item.file.data.disabled"
            class="download-btn download-txt"
            @click="playPpt(item, item.file.data.id)"
          >
            <v-icon small class="pr-2">fa-play</v-icon>View Slide
          </v-btn>
          <v-btn v-else-if="item.asset_type == 'video'" class="download-btn download-txt" @click="playVideo(item)">
            <v-icon small class="pr-2">fa-play</v-icon
            >Play
          </v-btn>
          <v-btn
            v-else-if="item.asset_type == 'document'"
            @click="openDocument(item.file.data.url, item.file.data.id)"
            class="download-btn download-txt"
          >
            <v-img src="/static/Vector.png" style="margin-right: 11px"></v-img>
            {{ item.file.data.mime_type.includes('pdf') ? 'Open' : 'Download' }}
          </v-btn>
          <v-btn
            v-else-if="item.asset_type == 'scorm'"
            class="download-btn download-txt"
            @click="playScorm(item, item.file.data.id)"
          >
            <v-img src="/static/Vector.png" style="margin-right: 11px"></v-img>
            Play
          </v-btn>
        </v-list-item-action>
      </v-row>
    </template>
  </v-list-item>
</template>
<script>
export default {
  name: 'ViewTrainingMaterialListItem',
  props: {
    item: {
      type: Object,
      default: null,
    },
    course: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      id: this.$route.params.id,
      startTime: 0,
      isPlaying: false,
      confirmStart: 'Do you want to carry on where you left off?',
      firstTime: true,
    };
  },
  methods: {
    openDocument(url, id) {
      window.open(url, '_blank');
    },
    playPpt(item, id) {
      this.$store.dispatch('setCurrentPpt', item).then(() => {
        this.$store.dispatch('setPlayPpt', true);
        this.$store.dispatch("setPlayVideo", false);
        this.isPlaying = false;
      });
    },
    playScorm(item, id) {
      this.$store.dispatch('setCurrentScorm', item).then(() => {
        this.$store.dispatch("setPlayVideo", false);
        this.$vuetify.goTo(200);
        this.isPlaying = true;
        this.$store.commit('setPlayScorm', true);
      });
    },
    playVideo(item) {
      this.$store.dispatch('setCurrentVideo', item).then(() => {
        this.$store.dispatch('setPlayVideo', true);
        this.$vuetify.goTo(200);
      });
    },
  },
  computed: {
    mimeType() {
      return this.item.file
        ? this.item.file.hasOwnProperty('data')
          ? this.item.file.data.mime_type
          : this.item.file.mime_type
        : 'link';
    },
    icon() {
      var icon = '';
      switch (this.mimeType) {
        case 'link':
          icon = 'fa fa-link';
          break;
        case 'video/mp4':
          icon = 'fa fa-video';
          break;
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          icon = 'fa-file-word';
          break;
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
          icon = 'fa-file-ppt';
          break;
        case 'application/pdf':
          icon = 'fa-file-pdf';
          break;
        case 'application/x-zip-compressed':
          icon = 'fa-photo-film-music';
          break;  
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          icon = 'fa-file-spreadsheet';
          break;  
        default:
          icon = 'fa-file';
          break;
      }
      return icon;
    },
  },
};
</script>
<style>
.list-icon {
  margin: auto !important;
  vertical-align: middle;
}
.v-list {
  padding: 0px 0 !important;
}
</style>
